"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EUnits = void 0;
let EUnits = exports.EUnits = /*#__PURE__*/function (EUnits) {
  EUnits["area"] = "\u043C\xB2";
  EUnits["sotki"] = "\u0441\u043E\u0442.";
  return EUnits;
}({});